var _circle, _path, _path2, _path3, _ellipse, _path4, _path5, _circle2, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHauntedFlashlightContrast = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.40002 43.4834C3.40002 40.1375 5.78748 37.2679 9.07762 36.6593L14.5006 35.6562V51.2484L9.15414 50.3213C5.82848 49.7446 3.40002 46.8587 3.40002 43.4834Z",
    fill: "#1E1E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5004 35.6562H41.0648V51.2484H14.5004C14.5004 51.2484 11.8696 50.5105 11.8696 43.4523C11.8696 36.3941 14.5004 35.6562 14.5004 35.6562Z",
    fill: "#1E1E1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9827 43.4523C61.9827 52.1522 57.8485 59.2048 52.7487 59.2048C52.0868 59.2048 51.4413 59.086 50.8189 58.8603L45.6527 56.3174L38.3126 52.5913C36.8482 51.8479 35.631 50.669 35.2075 49.0822C34.8517 47.7488 34.52 45.8787 34.52 43.5397C34.52 41.1585 34.8637 39.2632 35.2268 37.9255C35.6448 36.3853 36.8166 35.2314 38.2273 34.4851L46.2623 30.2342L50.8189 28.0442C51.4413 27.8185 52.0868 27.6997 52.7487 27.6997C57.8485 27.6997 61.9827 34.7524 61.9827 43.4523Z",
    fill: "#1E1E1E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.6413,
    cy: 43.2598,
    rx: 6.54485,
    ry: 13.5709,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4601 41.1423C45.4601 34.9504 48.1978 31.1218 48.8609 30.17C45.2676 32.2875 38.6394 35.0787 37.1507 36.362C35.6621 37.6453 35.6749 40.0836 35.5145 41.7839L45.4601 41.1423Z",
    fill: "#1E1E1E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1402 36.8657C14.203 36.716 14.3494 36.6187 14.5117 36.6187H33.9667C34.2401 36.6187 34.4341 36.8851 34.3502 37.1452L33.9684 38.3286C33.9147 38.495 33.7599 38.6078 33.585 38.6078H14.0155C13.7276 38.6078 13.5326 38.3146 13.6439 38.0491L14.1402 36.8657Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4297,
    cy: 37.7416,
    r: 1.26454,
    fill: "white",
    stroke: "#1E1E1E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8973 47.9894C47.9229 48.2105 48.1233 48.3706 48.3414 48.3268C49.3868 48.1168 50.3378 47.5661 51.0417 46.7552C51.834 45.8425 52.2559 44.6663 52.2245 43.4581C52.1931 42.2499 51.7106 41.0972 50.872 40.227C50.1269 39.4537 49.1486 38.9532 48.0937 38.7978C47.8736 38.7653 47.6818 38.9357 47.6678 39.1577L47.4337 42.8661C47.4036 43.3436 47.416 43.8229 47.4709 44.2983L47.8973 47.9894Z",
    fill: "#1E1E1E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.777 31.2934L75.0893 16.7923C75.1279 16.8353 75.1704 16.8831 75.2164 16.9356C75.4746 17.2298 75.8456 17.6719 76.291 18.2569C77.182 19.4272 78.3697 21.1684 79.5468 23.4418C81.9007 27.9878 84.2107 34.6588 84.0253 43.1527C83.8398 51.6477 81.2388 58.4031 78.6841 63.0352C77.4067 65.3512 76.1418 67.1347 75.1984 68.3369C74.7268 68.9379 74.3358 69.3933 74.0642 69.697C74.0121 69.7552 73.9644 69.8079 73.9213 69.855L51.7928 55.6261C51.7678 55.593 51.7333 55.5466 51.6905 55.487C51.5909 55.3483 51.4463 55.1385 51.2717 54.8607C50.9223 54.3048 50.4532 53.4771 49.9831 52.4013C49.043 50.2499 48.1 47.109 48.1 43.1636C48.1 39.2193 49.0424 36.2274 49.9778 34.2279C50.4458 33.2275 50.9124 32.4749 51.259 31.9757C51.4323 31.7261 51.5755 31.54 51.6738 31.418C51.7176 31.3637 51.7524 31.3221 51.777 31.2934Z",
    stroke: "#1E1E1E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHauntedFlashlightContrast);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HauntedFlashlightContrast.de39fa5765471a747b302549e7e7436c.svg";